import Vue from "vue";
import router from "@/router";

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({ path: "/login" });
  localStorage.setItem("yc_token", "");
  let token = localStorage.getItem("yc_token");
  Vue.axios_base.headers.common["token"] = token;
  window.location.reload();
};
/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 400: 客户端请求的语法错误，服务器无法理解
    case 400:
      // Toast('请求错误')
      toLogin();
      break;
    // 401: 未登录状态，跳转登录页
    case 401:
      // Toast('您还未登录，请登录')
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      // Toast('登录过期，请重新登录')
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    // 404请求不存在
    case 404:
      // Toast('请求的资源不存在或地址错误')
      break;
    //   // 408服务器等待客户端发送的请求时间过长，超时
    // case 408:
    //   Toast('请求超时')
    //   break
    //   // 500服务器内部错误，无法完成请求
    // case 500:
    //   Toast('服务器繁忙，请稍后再试')
    //   break
    //   // 501服务器不支持请求的功能，无法完成请求
    // case 501:
    //   Toast('服务器繁忙，请稍后再试')
    //   break
    //   // 502Bad Gateway网关或者代理工作的服务器尝试执行请求时，从远程服务器接收到了一个无效的响应
    // case 502:
    //   Toast('网关错误')
    //   break
    //   // 503由于超载或系统维护，服务器暂时的无法处理客户端的请求
    // case 503:
    //   Toast('服务器繁忙，请稍后再试')
    //   break
    //   // 504充当网关或代理的服务器，未及时从远端服务器获取请求
    // case 504:
    //   Toast('网关超时')
    //   break
    //   // 505服务器不支持请求的HTTP协议的版本，无法完成处理
    // case 505:
    //   Toast('HTTP版本不受支持')
    //   break
    default:
      console.log(other);
  }
};

export default errorHandle;



// WEBPACK FOOTER //
// ./src/api/errorHandle.js